export default __webpack_public_path__ + "static/media/icons8-truck.f546bca8.svg";